import type { BidsPageResponse } from '@skinstep/shared';
import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';

const PAGE_SIZE = 10;

export function useLotBidsInfinite(lotId: string, enabled: boolean) {
  return useInfiniteQuery({
    queryKey: ['lot-bids', lotId],
    enabled,
    initialPageParam: null as number | null,
    queryFn: ({ pageParam, signal }) => {
      const params = new URLSearchParams({ limit: String(PAGE_SIZE) });
      if (pageParam != null) params.set('cursor', String(pageParam));
      return api.get<BidsPageResponse>(`/api/lots/${lotId}/bids?${params.toString()}`, { signal });
    },
    getNextPageParam: (lastPage) => lastPage.next_cursor,
  });
}
